module.exports = __webpack_public_path__ + "static/img/roleplay-hcp.1e7cd672.png";